export const USERDEFINEDFIELDS_LOADING = 'REDUX_SAGA_USERDEFINEDFIELDS_LOADING';
export const USERDEFINEDFIELDS_DATA_SUCCESS = 'REDUX_SAGA_USERDEFINEDFIELDS_DATA_SUCCESS';
export const USERDEFINEDFIELDS_ADD_UDF_TO_TOUREVENT = 'REDUX_SAGA_USERDEFINEDFIELDS_ADD_UDF_TO_TOUREVENT';
export const UPDATE_USERDEFINEDFIELD = 'REDUX_SAGA_UPDATE_USERDEFINEDFIELD';
export const RESET_USERDEFINEDFIELDS = "REDUX_SAGA_RESET_USERDEFINEDFIELDS";
export const USERDEFINEDFIELDS_DATA_ERROR = 'REDUX_SAGA_USERDEFINEDFIELDS_DATA_ERROR';

export const actionGetUserDefinedFields = (dispatch, type, id, listOfIds) => {
    dispatch({ type: USERDEFINEDFIELDS_LOADING, payload: { type: type, id: id, listOfIds: listOfIds } })
};

export const actionAddUDFToTourEvent = (dispatch, bookingID, toureventID) => {
    dispatch({ type: USERDEFINEDFIELDS_ADD_UDF_TO_TOUREVENT, payload: { bookingID: bookingID, toureventID: toureventID } })
}

export const actionUpdateUDF = (dispatch, bookingID, toureventID, categoryName, udfID, value) => {
    dispatch({ type: UPDATE_USERDEFINEDFIELD, payload: { bookingID: bookingID, toureventID: toureventID, categoryName: categoryName, udfID: udfID, value: value } })
};

export const actionResetUDFs = (dispatch) => {
    dispatch({ type: RESET_USERDEFINEDFIELDS })
};
